export type BouncedEmailStatus =
  'Review' | 'No Contacts' | 'Resolved' | 'Ignored';

export const BOUNCED_EMAIL_STATUSES: BouncedEmailStatus[] = [
  'Review',
  'No Contacts',
  'Resolved',
  'Ignored',
];

export interface BouncedEmailContact {
  email: string;
  id: string;
  labels: string[];
  level: string;
  name: string;
  organizationId: string;
  organizationName: string;
  organizationDomain?: string;
  type: 'organization' | 'building' | 'controlSystem';
}

export interface BouncedEmailHistoryEntry {
  timestamp: string;
  action: string;
  detail: string;
  userId: string;
  userName: string;
}

export interface BouncedEmail {
  email: string;
  status: BouncedEmailStatus;
  contacts: BouncedEmailContact[];
  count: number;
  reason: string;
  history?: BouncedEmailHistoryEntry[];
  createdAt: string;
  updatedAt: string;
}

export interface BouncedEmailFilterOptions {
  statuses: string[];
  organizations: string[];
}

export interface BouncedEmailsReport {
  results: BouncedEmail[];
  paging: {
    totalRecords: number;
  };
}
